import { render } from "./PredictionEditor.vue?vue&type=template&id=5d94f976&scoped=true"
import script from "./PredictionEditor.vue?vue&type=script&lang=js"
export * from "./PredictionEditor.vue?vue&type=script&lang=js"

import "./PredictionEditor.vue?vue&type=style&index=0&id=5d94f976&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d94f976"]])

export default __exports__